import React from 'react'
import PropTypes from 'prop-types'
import { classNames as cn } from 'helpers'
import styles from './SlotColorTypesNew.module.scss'

const slotTypesDefault = [
  {
    id: 1,
    name: 'Standard type',
    color: '#F0F3F5',
    bgColor: '#FFFFFF',
  },
  {
    id: 2,
    name: 'Client is registered',
    color: '#1ABC97',
    bgColor: '#EAFFF8',
  },
  {
    id: 3,
    name: 'Help Club',
    color: '#FFC700',
    bgColor: '#FFF9E9',
  },
  {
    id: 4,
    name: 'Remote slot',
    color: '#FF0022',
    bgColor: '#FFE7EA',
  },
]

function SlotColorTypesNew() {
  return (
    <div
      className={cn({
        [styles.wrapper]: true,
      })}
    >
      <div className={styles.heading}>Slots information</div>
      <ul className={styles.color_list}>
        {slotTypesDefault.map(({ id, name, color, bgColor }) => (
          <li className={styles.color_item} key={id}>
            <div className={styles.borderMain}>
              <span
                className={styles.borderSq}
                style={{
                  backgroundColor: bgColor,
                  border: `1px solid ${color}`,
                }}
              >
                <span
                  className={styles.circleBorder}
                  style={{ border: `1px solid ${color}` }}
                >
                  <span
                    className={styles.circle}
                    style={{ backgroundColor: color }}
                  />
                </span>
              </span>
            </div>
            <span className={styles.color_label}>{name}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

SlotColorTypesNew.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      color: PropTypes.string,
    }),
  ).isRequired,
}

export default SlotColorTypesNew
